import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import {
  CustomMetricsClient,
  CustomMetricsMockClient,
  customMetricsApiRef,
  shouldUseCustomMetricsMock,
} from './api';
import {
  insightsUsageCatalogRouteRef,
  insightsUsageRouteRef,
  insightsUsageSearchRouteRef,
  insightsUsageTemplatesRouteRef,
  insightsUsageUsersRouteRef,
  rootRouteRef,
} from './routes';

export const customMetricsPlugin = createPlugin({
  id: 'custom-metrics',
  apis: [
    createApiFactory({
      api: customMetricsApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory({ configApi, discoveryApi, fetchApi }) {
        if (shouldUseCustomMetricsMock(configApi)) {
          return new CustomMetricsMockClient();
        }
        return new CustomMetricsClient({ configApi, discoveryApi, fetchApi });
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
    usage: insightsUsageRouteRef,
    usageUsers: insightsUsageUsersRouteRef,
    usageCatalog: insightsUsageCatalogRouteRef,
    usageTemplates: insightsUsageTemplatesRouteRef,
    usageSearch: insightsUsageSearchRouteRef,
  },
});

export const CustomMetricsInsightsPage = customMetricsPlugin.provide(
  createRoutableExtension({
    name: 'CustomMetricsInsightsPage',
    component: () =>
      import('./components/InsightsPage/InsightsPage').then(
        m => m.CustomMetricsInsightsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
